<template>
  <LayoutAuth :validation-errors="validationErrors">
    <template v-slot:title>
      Redefinir Senha
    </template>
    <ForgotPassword @validationErrors="handleValidationErrors" />
  </LayoutAuth>
</template>
<script>
import ForgotPassword from "../components/ForgotPassword";
import LayoutAuth from "../layouts/LayoutAuth";
export default {
  components: {
    LayoutAuth,
    ForgotPassword
  },
  data() {
    return { validationErrors: "" };
  },

  methods: {
    handleValidationErrors(payload) {
      this.validationErrors = payload;
    }
  }
};
</script>
